// extracted by mini-css-extract-plugin
export var menuModal = "menu-modal-module--menu-modal--HhYS6";
export var show = "menu-modal-module--show--kfY7K";
export var closeButton = "menu-modal-module--close-button--UZPSm";
export var menuContent = "menu-modal-module--menu-content--Q7YFh";